module.exports = __webpack_public_path__ + "static/media/moon_grey-min.f8d5cc92.png";